// Textos da tela de fechamento da taxa Quero Pago para os valores que a API devolve.
export const PAYABLE_TYPES = {
  credit: 'Crédito',
  refund: 'Reembolso',
  chargeback: 'Chargeback',
  refund_failure: 'Falha de reembolso',
  refund_chargeback: 'Chargeback de reembolso',
};

export const SPECIAL_TOMADORES = {
  quero_self: 'CNPJ da própria Quero',
  without_tomador: 'Cobrança sem instituição',
};

export const EMISSION_STATUSES = {
  pending: 'Pendente',
  admitted: 'Admitida',
  processing: 'Em processamento',
  finalized: 'Emitida',
  rejected: 'Recusada',
  submission_failed: 'Falha no envio',
};

export function formatCnpj(document) {
  if (!document) return '-';

  return document.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
}
